import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { useState } from "react"
import {
  extractProperty,
  getAccordionItems,
  menuContactClick,
  type AccordionItem,
} from "utils"
import AccordionItemComp from "./AccordionItem"

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`

interface AccordionProps {
  data: any
  hideButton?: boolean
  initialClosed?: boolean
  isSmartBlockRenderer?: boolean
}

export default function AccordionComponent({
  data,
  hideButton = false,
  initialClosed,
  isSmartBlockRenderer = false,
}: AccordionProps) {
  const title = extractProperty(data, "tabTitle")
  const accordionItems: AccordionItem[] = getAccordionItems(data)
  const [openAccordion, setOpenAccordion] = useState<number | null>(
    initialClosed ? null : 0,
  )
  const handleAccordionToggle = (index: number) => {
    const isExpanded = openAccordion === index
    setOpenAccordion(openAccordion === index ? -1 : index)
    const clickedItem = accordionItems[index]
    menuContactClick(
      clickedItem.itemTitle || "",
      isExpanded ? "פתיחה" : "סגירה",
    )
  }

  return (
    <StyledLayout>
      {isSmartBlockRenderer && <Typography variant="h2">{title}</Typography>}
      {accordionItems.map((item, i) => (
        <AccordionItemComp
          key={i}
          item={item}
          index={i}
          isExpanded={openAccordion === i}
          onToggle={() => handleAccordionToggle(i)}
          hideButton={hideButton}
        />
      ))}
    </StyledLayout>
  )
}
